import { createContext, ReactNode, useContext, useEffect, useState } from 'react';
import { useCompanyProfileFields } from './CompanyProfileFields.provider';
import * as vp from 'vopay';

export type PendingDataCtx = {
  pendingData: unknown;
  hasPendingData: boolean;
  initPendingData: (data: { [key: string]: string | number | boolean }) => void;
  updatePendingData: (data: { [key: string]: string | number | boolean }) => void;
  reset: () => void;
};

export const PendingDataContext = createContext<PendingDataCtx>({
  pendingData: {},
  hasPendingData: false,
  initPendingData: () => {},
  updatePendingData: () => {},
  reset: () => {},
});

export const PendingDataProvider = ({ children }: { children: ReactNode }): React.JSX.Element => {
  const [initData, setInitData] = useState<vp.AccountPermissions>({});
  const [pendingData, setPendingData] = useState<{ [key: string]: string | number | boolean }>({});
  const [hasPendingData, setHasPendingData] = useState(false);
  const { setMakeFieldsVisible, setFromReviewPage } = useCompanyProfileFields();
  useEffect(() => {
    setHasPendingData(Object.keys(initData).some((key) => initData[key] !== pendingData[key]));
  }, [pendingData]);

  function initPendingData(data: { [key: string]: string | number | boolean }) {
    setInitData(data);
  }

  function updatePendingData(data: { [key: string]: string | number | boolean }) {
    setPendingData({ ...pendingData, ...data });
  }

  function reset() {
    setInitData({});
    setPendingData({});
    setHasPendingData(false);
    setMakeFieldsVisible(false);
    setFromReviewPage(false);
  }

  return (
    <PendingDataContext.Provider value={{ pendingData, hasPendingData, initPendingData, updatePendingData, reset }}>
      {children}
    </PendingDataContext.Provider>
  );
};

export const usePendingData = (): PendingDataCtx => useContext(PendingDataContext);
